import { render, staticRenderFns } from "./TelegramMessageComposer.vue?vue&type=template&id=5184d9e8&lang=pug&"
import script from "./TelegramMessageComposer.vue?vue&type=script&lang=js&"
export * from "./TelegramMessageComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports